import React, { Component } from 'react';
import { Divider, Button, Card } from 'antd';
import { AfspLayout } from '@bit/ui-common.ui-components/afsp';
import { externalDomainList } from '../../utils/externalDomainList';
import { ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';

const { setEnvPrefix, getPathParams } = ssCommonUtils,
    imagesPath = '/home/images',
    layout = {
        size: {
            header: 'xs',
            footer: 'xs'
        },
        images: {
            usePathname: false,
            logo: setEnvPrefix(`${imagesPath}/dhs-logo-01.png`),
            user: setEnvPrefix(`${imagesPath}/user-icon-01.png`),
        },
        controlType: 'home',
        bgc: '#e6e6e6'
    };

export default class ExternalLinkWarning extends Component {
    constructor(props) {
        super(props);

        this.state = {
            url: ''
        }
    }

    componentDidMount() {
        let pathParams = getPathParams();

        if (pathParams) {

            let url = decodeURIComponent(pathParams.url)

            let hostname = this.getHostName(url)

            let index = externalDomainList.indexOf(hostname);

            let split = url.split(hostname);

            let path = split[split.length - 1];

            let processedUrl = ( url.includes('https://') ? 'https://' : 'http://' ) + ( url.includes('http://www.') || url.includes('https://www.') ? 'www.' : '' ) + externalDomainList[index] + ( path.startsWith('/') || path === "" ? path : '/' + path );
            
            this.setState({
                url: processedUrl
            })
        }
    }

    processExternalRedirect() {
        location.href = this.state.url;
    }

    getHostName(url) {
        var match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);
        if (match != null && match.length > 2 && typeof match[2] === 'string' && match[2].length > 0) {
            return match[2];
        }
        else {
            return null;
        }
    }

    render() {
        const container = {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
        }

        const content = {
            borderRadius: '10px',
            borderStyle: 'solid',
            borderColor: 'rgb(255, 255, 255)',
            borderWidth: '1px',
            textAlign: 'center'
        }

        const title = {
            fontSize: '20px',
            fontWeight: 'bold',
            textAlign: 'left'
        }

        const text = {
            fontSize: '15px',
            marginBottom: '1.5rem'
        }

        const buttonContainer = {
            marginBottom: '0.5rem',
        }

        const button = {
            width: '50%',
            borderRadius: '20px',
            fontSize: '15px'
        }

        return (
            <div>
                <AfspLayout {...layout}>
                    <div style={container}>
                        <Card style={content}>
                            <div style={title}>External Redirect</div>
                            <Divider type="horizontal" />
                            {
                                externalDomainList.includes(this.getHostName(this.state.url)) ?
                                <div>
                                <div style={text}>You are now leaving the FTSP website and headed towards: <b>{this.state.url}</b></div>
                                <div style={text}>Are you sure you want to proceed?</div>
                                <div>
                                    <div style={buttonContainer}><Button style={button} type="primary" onClick={() => this.processExternalRedirect()}>Proceed</Button></div>
                                    <div style={buttonContainer}><a href={setEnvPrefix('/home')}><Button style={button}>Return to Home Page</Button></a></div>
                                </div></div> 
                                
                                : <div style={text}>Invalid Redirect URL</div>
                            }
                        </Card>
                    </div>
                </AfspLayout>
            </div>
        )
    }
}
